import { MessageCircle } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { EditorSection } from "./EditorSection";

const DEFAULT_MESSAGE = "Hallo {firma}, ich interessiere mich für den Führerschein und hätte gern Infos zu Terminen, Ablauf und Preisen. Viele Grüße";
const DEFAULT_LABEL = "Schreib uns auf WhatsApp";

const digits = (raw) => {
  let v = (raw || "").replace(/[^\d+]/g, "");
  if (v.startsWith("00")) v = v.slice(2);
  else if (v.startsWith("+")) v = v.slice(1);
  else if (v.startsWith("0")) v = "49" + v.slice(1);
  v = v.replace(/\+/g, "");
  return v.length >= 8 && v.length <= 15 ? v : "";
};

/** WhatsApp-Schnellkontakt: Nummer + vorgefertigte Nachricht (schwebender Button auf allen Seiten). */
export const WhatsAppEditor = ({ value, onChange, companyName, companyWhatsapp }) => {
  const cfg = value || {};
  const number = cfg.number ?? "";
  const effectiveNumber = number || companyWhatsapp || "";
  const d = digits(effectiveNumber);
  const enabled = cfg.enabled ?? !!d;
  const message = (cfg.message ?? DEFAULT_MESSAGE);
  const preview = message.replace("{firma}", companyName || "");
  const link = d ? `https://wa.me/${d}?text=${encodeURIComponent(preview)}` : "";
  const set = (patch) => onChange({ ...cfg, enabled, ...patch });

  return (
    <EditorSection
      icon={MessageCircle}
      title="WhatsApp-Schnellkontakt"
      subtitle="Schwebender Button auf allen Seiten – öffnet WhatsApp mit fertigem Text"
      quick
      testid="whatsapp"
      enabled={enabled}
      onToggleEnabled={(v) => onChange({ ...cfg, enabled: v })}
    >
      <div>
        <Label className="text-[11px] uppercase tracking-wide text-muted-foreground">WhatsApp-Nummer</Label>
        <Input
          value={number}
          onChange={(e) => set({ number: e.target.value })}
          placeholder={companyWhatsapp ? `Firmen-Stammdaten: ${companyWhatsapp}` : "z. B. 0177 8085085"}
          className="rounded-md mt-1"
          data-testid="edit-whatsapp-number"
        />
        <p className="text-[11px] mt-1 text-muted-foreground" data-testid="edit-whatsapp-number-hint">
          {d ? `Wird als +${d} verlinkt` : "Keine gültige Nummer – Button wird nicht angezeigt"}
        </p>
      </div>
      <div className="mt-3">
        <Label className="text-[11px] uppercase tracking-wide text-muted-foreground">Vorgefertigte Nachricht</Label>
        <Textarea
          value={message}
          onChange={(e) => set({ message: e.target.value })}
          rows={3}
          className="rounded-md mt-1 text-sm"
          data-testid="edit-whatsapp-message"
        />
        <p className="text-[11px] mt-1 text-muted-foreground">{"{firma}"} wird automatisch durch den Firmennamen ersetzt.</p>
      </div>
      <div className="mt-3">
        <Label className="text-[11px] uppercase tracking-wide text-muted-foreground">Button-Text</Label>
        <Input value={cfg.label ?? DEFAULT_LABEL} onChange={(e) => set({ label: e.target.value })} className="rounded-md mt-1" data-testid="edit-whatsapp-label" />
      </div>
      {link && (
        <a href={link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 mt-3 text-xs font-semibold text-[#128C7E] hover:underline" data-testid="edit-whatsapp-test-link">
          <MessageCircle size={12} /> Test-Link öffnen
        </a>
      )}
    </EditorSection>
  );
};
